<template>
  <main>
    <v-container class="tw-p-0">
      <v-sheet>
        <v-container class="tw-flex tw-justify-between tw-items-end tw-pt-8">
          <div>
            <!---<c-page-sub-title>Monroe County</c-page-sub-title>--->
            <c-page-title>{{ station.Site_Name }}</c-page-title>
          </div>
          <v-icon :size="64">
            mdi-weather-partly-cloudy
          </v-icon>
        </v-container>
        <v-container class="tw-pt-0">
          <v-tabs grow v-model="activeTab" show-arrows>
            <v-tab v-for="item in siteSections"
                   :key="item.value"
                   :value="item.value">
              {{ item.text }}
            </v-tab>
          </v-tabs>
          <v-divider />
        </v-container>
      </v-sheet>
    </v-container>
    <v-container v-if="loading">
      <v-skeleton-loader type="article" />
    </v-container>
    <v-tabs-items v-else v-model="activeTab">
      <v-tab-item key="summary">
        <the-tab-summary :records="records" :station="station" />
      </v-tab-item>
      <v-tab-item key="recent">
        <the-tab-recent :records="records" />
      </v-tab-item>
<!--      <v-tab-item key="tools">-->
<!--        <the-tab-tools />-->
<!--      </v-tab-item>-->
<!--      <v-tab-item key="historical">-->
<!--        <the-tab-historical />-->
<!--      </v-tab-item>-->
    </v-tabs-items>
  </main>
</template>

<script>
import siteSections from '@/common/data/siteSections'
import TheTabSummary from '@/components/pages/station/TheTabSummary'
import TheTabRecent from '@/components/pages/station/TheTabRecent'
// import TheTabHistorical from '@/components/pages/station/TheTabHistorical'
// import TheTabTools from '@/components/pages/station/TheTabTools'
export default {
  name: 'white',
  components: {
    // TheTabTools, TheTabHistorical,
    TheTabRecent, TheTabSummary
  },
  layout: 'white',
  async created () {
    console.log(this.$route)
    this.station = await this.$api.station.get('', {
      id: this.$route.params.id
    })
    delete this.station.web_url
    delete this.station.SiteId
    this.records = await this.$api.record.get('', {
      id: this.$route.params.id,
      period: 336
    })
    this.records = this.records.reverse()
    this.loading = false
  },
  data () {
    return {
      loading: true,
      activeTab: 'siteInformation',
      siteSections,
      station: {},
      records: []
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content{
  width: 100%;
}
</style>
